Vue.component('hubspot-component', {
    template: `
        <section class="embed-form-block block block--none">
            <div :id="'hubspotForm' + id"></div>
        </section>
    `,
    props: {
        formId: {
            type: String,
            required: true
        },
        portalId: {
            type: String,
            default: '145684717'
        },
        region: {
            type: String,
            default: 'eu1'
        }
    },
    data: function () {
        return {
            id: this._uid,
            form: {},
            formLoaded: false,
            loadInterval: 0,
        }
    },
    created() {
        this.init();
    },
    mounted() {
        this.loadInterval = setInterval(this.checkFormLoaded, 100);
    },
    beforeDestroy() {
        if (this.loadInterval) {
            clearInterval(this.loadInterval);
        }
    },
    methods: {
        init: function() {
            if (!this.$root.hubspotLoaded && typeof hbspt === 'undefined') {
                // Load external js
                const script = document.createElement('script');
                script.src = 'https://js-eu1.hsforms.net/forms/embed/v2.js';
                script.charset = 'utf-8';
                script.type = 'text/javascript';
                document.head.appendChild(script);

                this.$root.hubspotLoaded = true;
            }
        },
        loadForm: function() {
            if (typeof hbspt !== 'undefined' && hbspt.forms) {
                this.form = hbspt.forms.create({
                    region: this.region,
                    portalId: this.portalId,
                    formId: this.formId,
                    target: '#hubspotForm' + this._uid
                });
            }
        },
        checkFormLoaded: function() {
            this.formLoaded = typeof hbspt !== 'undefined' && typeof hbspt.forms !== 'undefined';
        }
    },
    watch: {
        formLoaded: function(newVal) {
            if (newVal) {
                clearInterval(this.loadInterval);
                this.loadInterval = 0;
                this.loadForm();
            }
        }
    }
});
